import axiosNew from '../../helpers/axios'

// CREATE CLIENT
export const createClient = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: 'support/user',
                method: 'POST',
                data: payload,
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET CLIENTS LIST
export const getClients = async (payload = {}) => {
    return new Promise(async (resolve) => {
        try {
            const {
                limit = 10,
                skip = 0,
                search = '',
                filter = {},
                includeDeleted,
                projectIds,
            } = payload
            const data = {
                skip,
                filter,
                limit,
                projectIds,
            }

            if (search?.length > 0) {
                data.search = search
            }

            if (typeof includeDeleted === 'boolean') {
                data.includeDeleted = includeDeleted
            }

            const response = await axiosNew({
                url: 'support/support-user-list',
                method: 'POST',
                data,
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET CLIENT BY ID
export const getClientById = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: `clients/${id}`,
                method: 'GET',
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// UPDATE CLIENT
export const updateClientService = async (id, payload) => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: `support/user/${id}`,
                method: 'PUT',
                data: payload,
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// DELETE CLIENT
export const deleteClient = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: `clients/${id}`,
                method: 'DELETE',
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// COUNT CLIENTS
export const countClients = async (payload = {}) => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: 'clients/count',
                method: 'POST',
                data: payload,
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// LIST PERMISSIONS — POST support/permissions/list
export const getProjectPermissions = async (supportUserId, projectId) => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: 'support/permissions/list',
                method: 'POST',
                data: {
                    supportUserId: String(supportUserId),
                    projectId: String(projectId),
                },
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// SET SUPPORT USER PERMISSIONS (per project)
export const setSupportUserPermissions = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: 'support/permissions/set',
                method: 'POST',
                data: payload,
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// PROJECT LIST FOR CLIENT MODAL
export const getProjectsForClientModal = async (payload = {}) => {
    const { skip = 0, filter = {}, limit = 10, search = '' } = payload
    return new Promise(async (resolve) => {
        try {
            const data = {
                skip,
                filter,
                limit,
            }

            // Add search outside filter if provided
            if (search?.length > 0) {
                data.search = search
            }

            const response = await axiosNew({
                url: 'support/project-list',
                method: 'POST',
                data,
            })
            resolve({
                data: response?.data?.result ?? response?.data?.data ?? [],
                isNext: response?.data?.isNext ?? false,
                skip: skip,
            })
        } catch (error) {
            resolve({
                data: [],
                isNext: false,
                skip: skip,
            })
        }
    })
}
